import gql from 'graphql-tag'

import { pageInfoData } from './common'
import { standardCompanyResult } from './company'
import { UserProfileFragment } from './profile'
export const OwnerToCompanyFragment = gql`
	fragment OwnerToCompanyFragment on _OwnerToCompany {
		A
		B
		company {
			...standardCompanyResult
		}
		user {
			id
			uid
			profileCollection {
				edges {
					node {
						...UserProfileFragment
					}
				}
			}
			_UserToCompanyRoleCollection {
				edges {
					node {
						companyRole {
							id
							company {
								id
								slug
								name
								hasLogo
								logoPath
								coverPath
								hasCover
								description
							}
						}
					}
				}
			}

			_UserToCompanyRoleCollection {
				edges {
					node {
						companyRole {
							companyRole_rolesCollection {
								edges {
									node {
										value
									}
								}
							}
						}
					}
				}
			}
			# currentPasswordCheck//need tiwari from sql
			god
			firebaseToken
		}
	}
	${standardCompanyResult}
	${UserProfileFragment}
`
export const standardTeamResult = gql`
	fragment standardTeamResult on Team {
		id
		name
		slug
		description
		teamDepartment {
			id
			key
			roTitle
			enTitle
			roCategory
			enCategory
		}
		noOfMembers
		teamMemberCollection {
			edges {
				node {
					id
					user {
						id
						uid
						profileCollection {
							edges {
								node {
									id
									aboutMe
									email
									firstName
									lastName
									hasAvatar
									avatarPath
									hasCover
									coverPath
									experienceCollection {
										edges {
											node {
												position
												company
											}
										}
									}
									# worksAt {
									# 	id
									# 	company
									# 	position
									# }
								}
							}
						}
					}
				}
			}
		}
		disabilityRatio
		averageAge
		maleRatio
		femaleRatio
		coverContentType
		coverPath
		coverBackground
		hasLogo
		logoContentType
		logoPath
		hasCover
		featuredVideo
		# locations {
		# 	id
		# 	address
		# 	location {
		# 		id
		# 		name
		# 		region2
		# 	}
		# 	zipCode
		# }
		_TeamToCompanyOfficesCollection {
			edges {
				node {
					companyOffices {
						id
						roLocations {
							id
							region2
							name
						}
						address
						zipCode
						hq
					}
				}
			}
		}
		company {
			id
			name
			slug
			hasLogo
			logoPath
			hasCover
			coverPath
			_OwnerToCompanyCollection {
				edges {
					node {
						...OwnerToCompanyFragment
					}
				}
			}
			industry {
				id
				key
			}
			companyOfficesCollection {
				edges {
					node {
						id
						address
						zipCode
						roLocations {
							id
							name
							region2
						}
						hq
					}
				}
			}
		}
	}
	${OwnerToCompanyFragment}
`

// export const TeamMemberFragment = gql`
// 	fragment TeamMember on User {
// 		id
// 		profileCollection {
// 			...UserProfile
// 		}
// 		_ig
// 		_ft
// 	}
// `

export const teamConnectionData = gql`
	fragment teamConnectionData on TeamConnection {
		edges {
			node {
				...standardTeamResult
			}
			cursor
		}
		pageInfo {
			...pageInfoData
		}
	}
	${standardTeamResult}
	${pageInfoData}
`
